<script>
import SearchBar from "../../../../../../components/forms/SearchBar.vue";
import MoreOptions from "./components/MoreOptions.vue";
import ViewAll from "./components/ViewAll.vue";
import ToggleButtons from "../../../../../../../Pages/components/buttons/ToggleButtons.vue";
import ItemsPerPageButton from "../../../../../../../Pages/components/buttons/ItemsPerPageButton.vue";
import { eventBus } from "../../../../../../../Pages/assets/eventBus.js";

export default {
    props: {
        search: {
            type: Boolean,
            default: false,
        },
        itemsPerPageOption: {
            type: Boolean,
            default: false
        },
        viewAll: {
            type: Boolean,
            default: false,
        },
        moreOptions: {
            type: Boolean,
            default: false,
        },
        gridListOption: {
            type: Boolean,
            default: false,
        },
        view: {
            type: String,
            default: null,
        },
        dataType: {
            type: String,
            default: null,
        },
        onMounted: {
            type: Function,
            required: true
        },
        perpage: {
            type: Number,
            default: 12,
            required: true
        },
        options: {
            type: Array,
            default: () => {
                return []
            },
            required: true
        },
        selectedFolderId: {
            type: [Number, String]
        },
        routeType: {
            type: String,
            default: null
        }
    },
    components: { SearchBar, MoreOptions, ViewAll, ToggleButtons, ItemsPerPageButton },
    methods: {
        toggleList(value) {
            eventBus.toggleListGridView(value)
        },
        searchInputTrigger() {
            eventBus.searchFoldersFiles(this.searchValue)
        }
    },
    data() {
        return {
            searchValue: null
        }
    },    
    computed: {
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        }
    }
};
</script>

<template>
    <div class="col-lg-8 col-sm-7 mt-0">
        <form @submit.prevent="" class="mt-4 mt-sm-0 float-sm-end d-flex align-items-center">
            <div v-if="viewAll">
                <ViewAll />
            </div>
            <div v-if="search">
                <div class="long-search-box search-box me-2 d-none d-xl-block">
                    <div class="position-relative">
                        <SearchBar
                            v-model="searchValue"
                            type="text"
                            classes="form-control bg-light border-light rounded"
                            placeholder="Search..."
                            :searchInputTrigger="searchInputTrigger"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                    </div>
                </div>
                <div class="d-flex justify-content-center">
                <b-dropdown
					class="d-inline-block d-xl-none ms-2"
					variant="black"
					menu-class="dropdown-menu-lg p-0"
					toggle-class="header-item noti-icon"
                    right
				>
					<template v-slot:button-content>
						<i class="mdi mdi-magnify"></i>
					</template>

					<form @submit.prevent="" class="p-3">
						<div class="form-group m-0">
                            <div class="input-group">
                                <SearchBar
                                    type="text"
                                    classes="form-control rounded"
                                    placeholder="Search..."
                                    v-model="searchValue"
                                    :searchInputTrigger="searchInputTrigger"
                                />
                            </div>
						</div>
					</form>
				</b-dropdown>
                </div>
            </div>
            <div v-if="itemsPerPageOption">
                <ItemsPerPageButton
                    :onMounted="onMounted"
                    :perpage="perpage"
                    :options="options"
                />
            </div>
            <div v-if="gridListOption">
                <ToggleButtons
                    :value="view"
                    :onClick="toggleList"            
                />
            </div>
            <div v-if="moreOptions">
                <MoreOptions 
                    :dataType="dataType"
                    :folderId="selectedFolderId"
                    :routeType="routeType"
                 />
            </div>
        </form>
    </div>
</template>

<style scoped>
    @media (min-width:1200px) and (max-width:1439px) {
        .long-search-box {
            width: 193px;
        }
    }
</style>
